// extracted by mini-css-extract-plugin
export default {"content":"DmbINpH1Sx9mjlIwQn3A","text":"B6ex8mkVClpGLxzC89K7","buttons":"vFcLpHPiIqwx6s0lkNHb","placeHolderShimmer":"RXmqKeXpMukdAoHfWF_a"};